/**
 * Phase 4 — Email-to-case (G.15). Client for a case's ingested email history + manual ingest trigger.
 */
export interface CaseEmailDto {
  CaseEmail_guid: string;
  CaseEmail_Subject: string | null;
  CaseEmail_From: string | null;
  CaseEmail_To: string | null;
  CaseEmail_Preview: string | null;
  CaseEmail_Direction: string;
  CaseEmail_Mailbox: string;
  CaseEmail_MatchedBy: string | null;
  CaseEmail_ReceivedAt: string | null;
}

export interface IngestSummary {
  mailbox: string;
  scanned: number;
  matched: number;
  stored: number;
  skippedExisting: number;
  unmatched: number;
}

function host(): string {
  return process.env.API_HOST?.trim() || window.location.origin;
}

class CaseEmailApi {
  static async listForCase(ticketGuid: string): Promise<CaseEmailDto[]> {
    const response = await fetch(`${host()}/api/v1/manager/ticket/${ticketGuid}/emails`, {
      method: 'GET',
      credentials: 'include',
    });
    if (!response.ok) throw new Error('Failed to load case emails');
    return response.json();
  }

  /** Manual ingest trigger. Returns 409 (thrown) when ingestion is disabled. */
  static async ingest(mailbox: 'court' | 'client', limit = 50): Promise<IngestSummary> {
    const response = await fetch(`${host()}/api/v1/manager/ingest-emails`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'include',
      body: JSON.stringify({ mailbox, limit }),
    });
    if (response.status === 409) throw new Error('Email-to-case ingestion is disabled on the server.');
    if (!response.ok) throw new Error('Failed to ingest emails');
    return response.json();
  }
}

export default CaseEmailApi;
